/** @format */

import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'compare-api-failure',
	templateUrl: './api-failure.component.html',
	styleUrls: ['./api-failure.component.scss'],
	imports: [HmfButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApiFailureComponent {
	readonly canRetryApiCall = input<boolean>();
	readonly tryAgain = output<void>();
	readonly continueBrowsing = output<void>();

	onTryAgainClick(): void {
		this.tryAgain.emit();
	}

	onContinueBrowsing(): void {
		this.continueBrowsing.emit();
	}
}
